import { Box, MenuItem, Select, Typography } from 'app/design';
import { matchSorter } from 'match-sorter';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDebounce } from 'react-use';
import {
  useWebphoneSelector,
  useWebphoneSlice,
} from '../../../../../data/webphone';
import { useWebphoneContext } from '../../../Store';
import useStyles from './styles';
import { span } from 'vega';
import { IconButton, Listbox, Slider } from '../../../../../design-lib';
import { SoundHigh, SoundOff } from 'iconoir-react';

const MicSetting = props => {
  const { filterText, setFilterMatching } = props;

  const SUB_ITEMS = [
    {
      component: MicDevice,
    },
    {
      component: MicVolume,
    },
  ];

  const [fullSubitemsList, setFullSubitemsList] = useState([...SUB_ITEMS]);

  const anyChildrenMatch = fullSubitemsList.find(setting => setting.matching)
    ? true
    : false;

  // useEffect(() => {
  //   setFilterMatching(anyChildrenMatch);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [fullSubitemsList, anyChildrenMatch]);

  const handleChildrenFilterMatching = index => matching => {
    setFullSubitemsList(list => {
      list[index].matching = matching;
      return [...list];
    });
  };

  // const classes = useStyles({ anyChildrenMatch });

  return (
    <>
      <MicDevice />
      <MicVolume />
    </>
  );

  // return (
  //   <Box sx={classes.mainCategory}>
  //     <Typography variant="h6" gutterBottom>
  //       Microphone
  //     </Typography>
  //     <div style={{ padding: '0px 8px' }}>
  //       {SUB_ITEMS.map((subitem, i) => {
  //         const Component = subitem.component;
  //         return (
  //           <Component
  //             key={i}
  //             filterText={filterText}
  //             setFilterMatching={handleChildrenFilterMatching(i)}
  //           />
  //         );
  //       })}
  //     </div>
  //   </Box>
  // );
};

const MicDevice = props => {
  const { settings } = useWebphoneSelector();
  const { actions } = useWebphoneSlice();
  const dispatch = useDispatch();
  // const { filterText, setFilterMatching } = props;
  const [state] = useWebphoneContext();
  const { mediaDevices, changeAudioInput, getPreferredDevice } = state;

  // const [doesMatch, setDoesMatch] = useState(true);
  const [selectedDevice, setSelectedDevice] = useState('default');

  // useEffect(() => {
  //   setFilterMatching(doesMatch);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [doesMatch]);

  // useEffect(() => {
  //   const matches = ['microphone input device'];
  //   setDoesMatch(matchSorter(matches, filterText).length ? true : false);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [filterText]);

  let audioInDevices = [];
  if (mediaDevices !== undefined) {
    audioInDevices = mediaDevices.filter(item => item.kind === 'audioinput');
    if (audioInDevices.length === 1) {
      if (selectedDevice !== audioInDevices[0].deviceId) {
        setSelectedDevice(audioInDevices[0].deviceId);
      }
    } else {
      // check if previous selection is available and select,
      // otherwise use default
      if (
        settings.input?.device &&
        audioInDevices.find(
          device => device.deviceId === settings.input?.device.deviceId,
        )
      ) {
        if (settings.input.device.deviceId !== selectedDevice) {
          setSelectedDevice(settings.input?.device.deviceId);
          changeAudioInput(settings.input?.device.deviceId);
        }
      } else {
        const device = getPreferredDevice('audioinput');
        if (device !== selectedDevice) {
          setSelectedDevice(device);
        }
      }
    }
  }

  const onDeviceChange = id => {
    changeAudioInput(id);
    setSelectedDevice(id);

    // save selected device
    if (id)
      dispatch(
        actions.set_setting({
          path: 'input.device',
          value: audioInDevices.find(device => device.deviceId === id),
        }),
      );
  };

  // const classes = useStyles({ doesMatch });
  return (
    <>
      <div className={`w-full`}>
        <Listbox
          label={'Input device'}
          className={`w-full`}
          value={selectedDevice}
          options={audioInDevices.map((deviceInfo, i) => ({
            label: (
              <>
                {' '}
                <span>{deviceInfo.label}</span>
                {deviceInfo.deviceId === 'default' ? (
                  <span
                    className={'text-gray-500 ml-1'}
                  >{`[System Default]`}</span>
                ) : deviceInfo.deviceId === settings.input?.device?.deviceId ? (
                  <span className={'text-teal-500 ml-1'}>{`[Preferred]`}</span>
                ) : null}
              </>
            ),
            value: deviceInfo.deviceId,
          }))}
          onChange={onDeviceChange}
        />
      </div>
    </>
  );

  // return (
  //   <Box sx={classes.subitem}>
  //     <div style={{}}>
  //       <Typography variant="body1" gutterBottom>
  //         Input Device
  //       </Typography>
  //       <Select
  //         size="small"
  //         style={{ width: '100%' }}
  //         value={selectedDevice}
  //         onChange={e => onDeviceChange(e.target.value)}
  //       >
  //         {audioInDevices.map((deviceInfo, i) => (
  //           <MenuItem key={i} value={deviceInfo.deviceId}>
  //             <span>{deviceInfo.label}</span>
  //             {deviceInfo.deviceId === 'default' ? (
  //               <span
  //                 className={'text-gray-500 ml-1'}
  //               >{`[System Default]`}</span>
  //             ) : deviceInfo.deviceId === settings.input?.device?.deviceId ? (
  //               <span className={'text-teal-500 ml-1'}>{`[Preferred]`}</span>
  //             ) : null}
  //           </MenuItem>
  //         ))}
  //         {settings.input?.device &&
  //         !audioInDevices.find(
  //           device => device.deviceId === settings.input?.device.deviceId,
  //         ) ? (
  //           <MenuItem disabled key={settings.input?.device.deviceId}>
  //             {settings.input?.device.label}
  //             <span className={'text-teal-500 ml-1'}>
  //               [Preferred - Disconnected]
  //             </span>
  //           </MenuItem>
  //         ) : null}
  //       </Select>
  //     </div>
  //   </Box>
  // );
};

const MicVolume = props => {
  const { settings } = useWebphoneSelector();
  const { actions } = useWebphoneSlice();
  const dispatch = useDispatch();
  const { filterText, setFilterMatching } = props;
  const [state] = useWebphoneContext();
  const { setMicVolume, getMicVolume } = state;

  // console.log('mic volue', getMicVolume());

  const [doesMatch, setDoesMatch] = useState(true);
  const [volume, setVolume] = useState(settings?.input.volume ?? 100);

  // useEffect(() => {
  //   setFilterMatching(doesMatch);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [doesMatch]);
  //
  // useEffect(() => {
  //   const matches = ['microphone volume'];
  //   setDoesMatch(matchSorter(matches, filterText).length ? true : false);
  // }, [filterText]);

  let micVol = getMicVolume() * 100;
  micVol = Math.round(micVol);

  // check if user has customized volume in app, otherwise use system volume for device
  if (!settings?.input.volume && micVol !== volume) {
    setVolume(micVol);
  }
  const onVolumeChange = value => {
    const vol = Math.round(value) / 100;
    setMicVolume(vol);
    setVolume(Math.round(value));
  };

  // store volume after user adjusts
  useDebounce(
    () => {
      dispatch(actions.set_setting({ path: 'input.volume', value: volume }));
    },
    500,
    [volume],
  );

  // const classes = useStyles({ doesMatch });

  return (
    <div className={`w-full flex space-x-2 items-center`}>
      <IconButton
        size={'sm'}
        variant={'ghost'}
        color={'neutral'}
        onClick={() => onVolumeChange(0)}
        pill
      >
        <SoundOff fr={undefined} />
      </IconButton>
      <Slider value={volume} onChange={onVolumeChange} min={0} max={100} />
      <IconButton
        size={'sm'}
        variant={'ghost'}
        color={'neutral'}
        pill
        onClick={() => onVolumeChange(100)}
      >
        <SoundHigh fr={undefined} />
      </IconButton>
    </div>
  );

  // return (
  //   <Box>
  //     <div style={{}}>
  //       <Typography variant="body1">Input Volume</Typography>
  //       <Typography variant="caption" component="div" gutterBottom>
  //         (how loud you sound to others)
  //       </Typography>
  //       <span>{volume}%</span>
  //       {/*<Slider value={volume} onChange={onVolumeChange} />*/}
  //     </div>
  //   </Box>
  // );
};

export default MicSetting;
